import { PRIO } from '../../../constants';

export const FETCH_NOTIFICATIONS_SAGA = PRIO + 'FETCH_NOTIFICATIONS_SAGA';

export const fetchNotificationsSaga = () => ({
  type: FETCH_NOTIFICATIONS_SAGA,
});
